import React from 'react'

import { Box } from 'ui/components/Box'

import { ToolbarActionsActions } from './ToolbarActionsActions'
import { ToolbarActionsAddRecord } from './ToolbarActionsAddRecord'
import { ToolbarActionsFields } from './ToolbarActionsFields'
import { ToolbarActionsFilters } from './ToolbarActionsFilters'
import { ToolbarActionsSync } from './ToolbarActionsSync'
import { ToolbarActionsViews } from './ToolbarActionsViews'

type ToolbarActionsProps = {}

export const ToolbarActions: React.FC<ToolbarActionsProps> = () => {
    return (
        <Box noShrink flex center gap="m">
            <ToolbarActionsSync />
            <ToolbarActionsFilters />
            <ToolbarActionsFields />
            <ToolbarActionsViews />
            <ToolbarActionsActions />
            <ToolbarActionsAddRecord />
        </Box>
    )
}
